module.exports = "<app-states [state]=\"state\"></app-states>"